import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';

type EnterpriseBffCourseContextType =
  | {
      coursePage?: EnterpriseCoursePageFieldsFragment | null | undefined;
      isCourseDataLoading?: boolean;
      error?: ApolloError;
    }
  | undefined;

const EnterpriseBffCourseContext = React.createContext<EnterpriseBffCourseContextType>(undefined);

export const useEnterpriseCoursePageData = () => {
  const context = useContext(EnterpriseBffCourseContext);

  return context?.coursePage;
};

export const useIsEnterpriseCourseDataLoading = () => {
  const context = useContext(EnterpriseBffCourseContext);

  return context?.isCourseDataLoading;
};

export const useEnterpriseCoursePageError = () => {
  const context = useContext(EnterpriseBffCourseContext);

  return context?.error;
};

export default EnterpriseBffCourseContext;
